<div *ngIf="mode === 'banner'" id="consent_blackbar"></div>
<span
  #teconsentlink
  *ngIf="mode === 'button'"
  id="teconsent"
  async="async"
  data-automation-id="cookie-preferences"
>
</span>
